
import Vue from "vue";

export default Vue.extend({
    name: "LabeledItem",
    props: {
        label: {
            type: String,
            required: true,
            default: "",
        },
        item: {
            type: String,
            required: false,
            default: "",
        },
        required: {
            type: Boolean,
            default: false,
        },
        boldText: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        className(): string {
            return this.boldText ? "label__item" : "";
        },
    },
});
